import { Box, styled } from "@mui/material";

export const OeKpisDataGridWrapper = styled(Box)({
  background: "#FFFFFF",
  height: "65vh",
  width: "100%",
  borderRadius: "12px",

  ".MuiDataGrid-root": {
    borderRadius: "12px",
    border: "none",
  },
  ".MuiDataGrid-columnHeaderTitleContainer": {
    justifyContent: "center",
  },

  // Make readonly grid have normal display cells
  ".MuiDataGrid-root:not(.MuiDataGrid-root--editable)": {
    ".MuiDataGrid-cell": {
      ".CustomCell": {
        color: "black",
      },
    },
  },

  // Hide borders
  ".MuiDataGrid-columnHeader": { border: "none !important" },
  ".MuiDataGrid-cell": {
    display: "flex",
    border: "none !important",

    ".CustomCell": {
      margin: "auto",
      borderRadius: "5px",
      padding: "6px",
      width: "100%",
      textAlign: "center",
      verticalAlign: "center",
    },

    "&:not([data-colindex='1'])": {
      ".CustomCell": {
        color: "#21212159",
      },
    },

    "&.MuiDataGrid-cell--editable": {
      ".CustomCell": {
        color: "black",
        border: "0.5px solid #C9C9C9",
      },
    },
  },

  ".MuiDataGrid-columnSeparator": { display: "none" },

  // Color alternating columns
  ".MuiDataGrid-cell:nth-of-type(odd)": { background: "#F5F9FA" },
  ".MuiDataGrid-cell:nth-of-type(even)": { background: "#FFFFFF" },

  // Make first column sticky (There is an empty column before it, thats why its nth-of-type(2))
  ".MuiDataGrid-cell:nth-of-type(2),  .MuiDataGrid-row div[data-colindex='0']":
    {
      position: "sticky",
      top: "0",
      left: "0",
      zIndex: 999,
    },
  " .MuiDataGrid-columnHeader:nth-of-type(2)": {
    background: "#FFFFFF",
    position: "sticky",
    top: "0",
    left: "0",
    border: "none",
    zIndex: 999,
  },
});
